import React from 'react';
import DataSourcesPage from './DataSourcesPage';

const WarsPage: React.FC = () => (
  <DataSourcesPage
    title="WARS"
    itemLabel="WARS Item"
    addButtonLabel="Add WARS Item"
    source="WARS"
    columns={[
      { key: 'type', label: 'Field' },
      { key: 'name', label: 'Text' },
      { key: 'code', label: 'Code' }
    ]}
    fields={[
      { key: 'type', label: 'Field', required: true },
      { key: 'name', label: 'Text', required: true },
      { key: 'code', label: 'Code', required: true }
    ]}
  />
);

export default WarsPage;
